import { render, staticRenderFns } from "./returnHome.vue?vue&type=template&id=3d1eb861&scoped=true&"
import script from "./returnHome.vue?vue&type=script&lang=js&"
export * from "./returnHome.vue?vue&type=script&lang=js&"
import style0 from "./returnHome.vue?vue&type=style&index=0&id=3d1eb861&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1eb861",
  null
  
)

export default component.exports